<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <v-card>
      <v-overlay :value="prepare">
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
      <v-form
        v-show="!prepare"
        id="form_user"
        ref="userForm"
        v-model="isValid"
        lazy-validation
      >
        <v-card-title>
          <span
            v-if="!user.id"
            class="headline"
          >New User</span>
          <span
            v-if="user.id"
            class="headline"
          >Update User</span>
          <v-spacer />
          <v-btn
            icon
            @click="close()"
          >
            <v-icon color="error">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-container class="px-0">
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  id="user_name"
                  v-model="user.name"
                  append-icon="mdi-account-box"
                  name="user_Name"
                  :rules="nameRules"
                  label="User Name*"
                  type="text"
                  autofocus
                  required
                  outlined
                  dense
                  :error-messages="getError('Name')"
                  @mouseup="dirtyError('Name')"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  id="user_emailId"
                  v-model="user.email"
                  append-icon="mdi-mail"
                  name="emailId"
                  label="E-mailID*"
                  :rules="emailRules"
                  required
                  outlined
                  dense
                  :error-messages="getError('Email')"
                  @mouseup="dirtyError('Email')"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-if="!user.id"
                  id="user_password"
                  v-model="user.password"
                  append-icon="mdi-lock"
                  name="password"
                  label="Password*"
                  :rules="passwordRules"
                  type="password"
                  required
                  outlined
                  dense
                  hint="Password must be 6 to 12 characters"
                  :error-messages="getError('Password')"
                  @mouseup="dirtyError('Password')"
                />
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="user.isAdmin"
                  label="Admin"
                  color="primary"
                />
              </v-col>
              <v-col
                v-if="!user.isAdmin"
                cols="12"
              >
                <v-autocomplete
                  v-model="user.roleId"
                  clearable
                  label="Role*"
                  :items="roles"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  open-on-clear
                  required
                  :rules="roleRules"
                  :error-messages="getError('role')"
                  @mouseup="dirtyError('role')"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <small> *indicates required field</small>
          <v-spacer />
          <v-btn
            id="close"
            color="error"
            class="white--text"
            style="position: relative"
            @click.native="close()"
          >
            Close
          </v-btn>

          <v-btn
            id="save"
            color="success"
            :disabled="!isValid"
            :loading="loader"
            @click.native="saveUser()"
          >
            {{ user.id ? "Update" : "Save" }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { failure } from "@/mixins/common";
export default {
  name: "UserForm",
  mixins: [failure],
  props: {
    open: {
      type: Boolean
    },
    userId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      prepare: false,
      loader: false,
      isValid: false,
      user: {},
      roles: [],
      errors: {},
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 25) || "Name must be less than 25 characters"
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 6 && v.length <= 12) ||
          "Password must be 6 to 12 characters"
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/.test(
            v
          ) || "E-mail must be valid"
      ],
      roleRules: [
        (v) => !!v || "Role is required"
      ]
    };
  },
  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(val) {
        this.$emit("update:open", val);
      }
    }
  },
  watch: {
    open: {
      immediate: true,
      handler(val) {
        if (val) {
          this.reset(true);
        }
      }
    }
  },
  methods: {
    getRoles() {
      let url = `${this.ADMIN_API_URL}/activeRoles`;
      this.$http.get(url).then((data) => {
        this.roles = data.body;
      });
    },
    saveUser() {
      if (!this.$refs.userForm.validate()) {
        return;
      }
      this.loader = true;
      let q;
      let url = `${this.ADMIN_API_URL}/users`;
      if (!this.user.roleId) {
        this.user.roleId = 0;
      }
      if (this.user.id) {
        q = this.$http.put(`${url}/${this.user.id}`, this.user);
      } else {
        q = this.$http.post(url, this.user);
      }
      q.then(
        (resp) => {
          this.$store.commit("showSnackbar", {
            message: resp.body.message
          });
          this.$emit("refresh");
          this.close();
        },
        function (failure) {
          this.loader = false;
          this.errors = failure.body.errors;
          this.handleFailure(failure);
        }
      );
    },
    getUser: function (id) {
      if (!id) {
        this.prepare = false;
        return;
      }
      let url = `${this.ADMIN_API_URL}/users/${id}`;
      this.$http.get(url).then(
        (resp) => {
          this.user = resp.body;
          this.prepare = false;
        },
        (failure) => {
          this.handleFailure(failure);
          this.close();
        }
      );
    },

    reset(init = false) {
      this.prepare = false;
      this.loader = false;
      this.isValid = true;
      this.errors = {};
      this.user = {};
      if (this.$refs.userForm) {
        this.$refs.userForm.reset();
      }
      if (init) {
        this.prepare = true;
        this.getRoles();
        this.$nextTick(() => {
            this.user = {
              isAdmin: true,
              roleId: 0
            };
            this.getUser(this.userId);
        });
      }
    },
    close() {
      this.$emit("update:open", false);
      this.reset();
    },
    getError(key) {
      return this.errors && this.errors[key] ? [this.errors[key]] : [];
    },
    dirtyError(key) {
      this.errors[key] = "";
    }
  }
};
</script>